<template>
  <div class="footer-outer">
    <div class="footer">
      <div class="info-item" v-if="!isMobile" style="cursor: pointer">
<!--        <img src="../assets/images/footer/shanda-logo.png"   @click="goToOutLink"   />
-->        <img src="../assets/images/footer/logo.png"  @click="goToLink"  />
        <div class="text">
          用数智技术助力客户实现创意和梦想
        </div>
      </div>
      <div class="info-item"  v-if="!isMobile">
        <div class="item-title" @click="$router.push('/scheme')">方案中心</div>
        <div class="text" @click="$router.push('/ExplorationVehicle')">隧道无人巡检机器人</div>
        <div class="text" @click="goToInfo(item)" v-for="item in schemeList" :key="item.title">{{ item.title }}</div>
      </div>
      <div class="info-item"  v-if="!isMobile">
        <div class="item-title"  @click="$router.push('/case')">应用案例</div>
        <div class="text" @click="$router.push('/case')">青岛地铁3号线</div>
        <div class="text" @click="$router.push('/case')">青岛地铁1号线</div>
        <div class="text" @click="$router.push('/case')">济南地铁1号线</div>
        <div class="text" @click="$router.push('/case')">胶州湾海底隧道</div>
      </div>
      <div class="info-item"  v-if="!isMobile">
        <div class="item-title">联系我们</div>
        <div class="text">客服QQ：372618870</div>
        <div class="text">联系电话：18763801896、15689701301</div>
        <div class="text">(工作日：08:30-11:30 13:00-18:00)</div>
        <div class="text" @click="goToMap">地址：山东省济南市高新区齐鲁软件园D座5层B512</div>
      </div>
      <div class="info-item qrcode" style="text-align: center">
        <img src="../assets/images/footer/httpcivil.png" alt=""/>
        <div class="text">关注微信公众号</div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="slogan-box">
        <img src="http://www.datacreateai.com/r/cms/www/default/images/index/slogan.png"  alt="" class="slogan">
      </div>
      <p style="padding-top: 24px;margin: 0; text-align: center;color: #aeaeae;font-size: 13px">
        <span>Copyright </span> © <span id="years">{{ year }} </span>
        <span>山东数创智能科技有限公司</span>
        <a href="http://beian.miit.gov.cn/" class="mini-p" target="_blank" style="color:#aeaeae;text-decoration: none;cursor: pointer">鲁ICP备19059626号-1</a>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "footerView",
  data(){
    return {
      isMobile: false,
      schemeList:[
        {
          title:'隧道衬砌病害检测算法',
          info:'为实现隧道衬砌几何形态的精准测量，本方案采用自主研发的隧道衬砌几何检测算法系统，基于三维点云处理和特征匹配技术，构建高精度的隧道几何形态检测平台。',
          url:'/static/img3.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）改进ICP点云配准算法，配准精度达2mm</div>" +
              " <div class='content-item'>（二）断面收敛自动分析模块，支持200+测线同步计算</div>" +
              " <div class='content-item'>（三）三维变形可视化系统，变形趋势预测准确率>90%</div>" +
              " <div class='content-item'>（四）自动报告生成功能，一键输出10+项关键指标</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）测量精度达到行业领先水平</div>" +
              " <div class='content-item'>（二）处理速度快，满足工程检测需求</div>" +
              " <div class='content-item'>（三）支持多种标准断面比对</div>" +
              " <div class='content-item'>（四）操作简便，自动化程度高</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm2.png' alt=''></div>"
        },
        {
          title:'道桥工程检测监测方案',
          info:'本方案采用多传感器融合及无人机检测等手段，针对道路和桥梁的状态进行监测。',
          url:'/static/img8.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）多源传感器网络实时监测：实时采集桥梁/道路的应力、应变、振动频率、位移等关键参数,实现对结构健康状态的监测。</div>" +
              " <div class='content-item'>（二）无人机智能巡检系统：搭载高清摄像头、红外热像仪、激光雷达，快速识别路面裂缝、桥面铺装破损、结构表面剥落等可见缺陷。</div>" +
              " <div class='content-item'>（三）数据分析与智能预警：整合传感器数据、无人机影像、InSAR（卫星雷达干涉）形变数据，构建多维度数据库；自动生成维修优先级建议，优化养护资源配置。 </div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）全周期覆盖，精准高效：传感器网络24/7连续监测。</div>" +
              " <div class='content-item'>（二）高精度与多维度融合：激光雷达与摄影测量技术结合，多源数据（传感器+无人机+卫星）交叉验证。</div>" +
              " <div class='content-item'>（三）智能决策支持：深度学习算法自动识别病害类型，基于GIS/BIM的可视化平台，支持病害定位、历史追溯与方案模拟。</div>" +
              " <div class='content-item'>（四）成本与安全优势：减少高空车、封闭交通等高成本作业，无人机替代高危区域人工巡检，规避人员坠落风险。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm7.png' alt=''></div>"
        },
        {
          title:'矿山工程检测监测方案',
          info:'本方案设计了一套集智能监测、实时预警与水源识别于一体的矿井水文地质监测预报预警平台。该系统依托物联网、大数据分析和人工智能技术，对地下水水位、水压、水质、视频监控、水仓流量等关键参数进行全天候动态监测，构建矿山全生命周期的智能化水文管理体系。\n',
          url:'/static/img9.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）多参数智能监测：通过高精度传感器网络，实时采集地下水动态数据（水位、水压）、水质指标、关键区域视频影像及水仓流量信息，形成综合数据库，为分析决策提供数据支撑。</div>" +
              " <div class='content-item'>（二）突水水源快速识别：针对矿山突水事故中危害性显著的第四系松散层潜水和海水入侵，系统通过水质特征比对与机器学习算法，实现水源类型的秒级判定，为应急响应争取宝贵时间。</div>" +
              " <div class='content-item'>（三）基于阈值判定与趋势预测模型，平台可自动触发分级预警,并通过短信、APP推送等方式通知管理人员，确保风险早发现、早处置。</div>" +
              " <div class='content-item'>（四）全生命周期管理：从矿山建设到闭坑阶段，平台持续积累水文地质数据，生成动态评价报告，辅助优化防治水工程设计，提升长期安全运营能力。</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）智能化分析：利用AI算法实现数据异常检测与突水概率预测，降低人为误判风险。</div>" +
              " <div class='content-item'>（二）可视化展示：通过三维地质模型与动态看板，直观呈现监测数据及风险分布。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm8.png' alt=''></div>"
        }
      ],
      year: new Date().getFullYear(),
    }
  },
  created() {
    this.year = new Date().getFullYear()
    this.checkScreenSize()
  },
  mounted() {
    window.addEventListener('resize', this.checkScreenSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize)
  },
  methods:{
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768
    },
    goToLink(){
      window.location.href = "http://www.datacreateai.com/"
    },
    goToOutLink(){
      window.location.href = "https://geo.sdu.edu.cn/"
    },
    goToMap(){
      let position = 'https://map.baidu.com/poi/%E9%BD%90%E9%B2%81%E8%BD%AF%E4%BB%B6%E5%9B%AD%E5%88%9B%E4%B8%9A%E5%B9%BF%E5%9C%BA-D%E5%BA%A7/@13040160.174314182,4368522.1179471975,16.76z?uid=75036835c791e7d15f0d02a5&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl'
      window.open(position, '_blank')
    },
    goToInfo(item){
      this.$router.push({
        path: '/product',
        query:{
          ...item
        }
      })
    }
  }

}
</script>

<style scoped lang="scss">
.footer-outer{
  background: #141414;
}
.footer{
  min-height: 270px;
  height: auto;
  background: #141414; 
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  position: relative; 
  overflow: hidden;
  box-sizing: border-box;
  .info-item{
    padding: 0 2vw;
    display: flex;
    flex-direction: column;
    .item-title{
      font-size: 16px;
      color: #FFFFFF;
      line-height: 22px;
      margin-bottom: 12px;
    }
    .text{
      font-size: 14px;
      color: #6F6F6F;
      line-height: 30px;
    }
    &:nth-child(2),&:nth-child(3){
      .text{
        cursor: pointer;
        &:hover{
          opacity: .8;
          color: #fff;
        }
      }
    }
    &:nth-child(2),&:nth-child(3),&:nth-child(4){
      align-items: flex-start;
      min-height: 150px;
    }
    &:first-child{
      min-width: 150px;
      padding: 0;
      min-height: 150px;
      background: url(../assets/images/footer/BG.png) no-repeat center;
      background-size:  100% auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      img{
        margin-bottom: 24px;
        width: 101px;
        max-width: 100%;
      }
    }
    &.qrcode{
      position: relative;
      right: auto;
      display: inline;
      flex-direction: column;
      align-items: center;

      img{
        width: 101px;
        max-width: 100%;
      }
    }
  }
}
.footer-bottom{
  text-align: center;
  padding-bottom: 33px;
  font-size: 13px;
  color: rgba(255,255,255,.6);
  .slogan-box{
    img{
      height: 34px;
    }
  }
  p{
    a{
      margin-left: 16px;
    }
  }
}
/* 大屏幕PC适配 (≥1600px) */
@media screen and (min-width: 1600px) {
  .footer {
    min-height: 270px;
    padding: 40px 20px;
    .info-item {
      padding: 0 2vw;
    }
    .info-item:first-child,
    .info-item.qrcode {
      min-width: 150px;
      img {
        width: 101px;
      }
    }
  }
}

/* 中屏幕PC适配 (1400-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1400px) {
  .footer {
    min-height: 270px;
    padding: 40px 20px;
    .info-item .item-title {
      font-size: 18px;
    }
    .info-item {
      padding: 0 2vw;
      .text {
        font-size: 14px;
      }
    }
    .info-item:first-child,
    .info-item.qrcode {
      min-width: 130px;
      img {
        width: 90px;
      }
    }
  }
}

/* 小屏幕PC适配 (1200-1399px) */
@media screen and (max-width: 1399px) and (min-width: 1200px) {
  .footer {
    min-height: 250px;
    padding: 40px 20px;
    .info-item .item-title {
      font-size: 17px;
    }
    .info-item {
      padding: 0 2vw;
      .text {
        font-size: 14px;
      }
    }
    .info-item:first-child,
    .info-item.qrcode {
      min-width: 120px;
      img {
        width: 85px;
      }
    }
  }
}

/* 大屏平板适配 (1025-1199px) */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .footer {
    min-height: 230px;
    padding: 35px 20px;
    .info-item .item-title {
      font-size: 16px;
    }
    .info-item {
      padding: 0 1.5vw;
      .text {
        font-size: 13px;
        line-height: 28px;
      }
    }
    .info-item:first-child,
    .info-item.qrcode {
      min-width: 110px;
      left: 40%;
      top: 32px; 
      img {
        width: 80px;
      }
    }
  }
  .footer-bottom {
    padding-bottom: 25px;
  }
}

/* 平板设备适配 (769-1024px) */
@media screen and (max-width: 1024px) and (min-width: 769px) {
  .footer {
    padding: 30px 15px;
    .info-item {
      padding: 0 1.5vw;
      .item-title {
        font-size: 16px;
      }
      .text {
        font-size: 13px;
        line-height: 26px;
      }
    }
    .info-item:first-child,
    .info-item.qrcode {
      min-width: 100px; 
      top: 32px; 
      img {
        width: 70px;
      }
    }
  }
  .footer-bottom {
    padding-bottom: 25px;
    p {
      font-size: 12px;
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .footer {
    justify-content: center;
    padding: 40px 16px 20px;
    flex-direction: column;
    min-height: unset;
    .info-item {
      margin-bottom: 20px;
      align-items: center;
      padding: 0;
      min-height: auto;
      .text {
        text-align: center;
        font-size: 13px;
        line-height: 24px;
      }
    }
    .info-item:first-child {
      min-width: auto;
      margin-bottom: 30px;
      background-position: center bottom;
      background-size: auto 40%;
      min-height: auto;
      img {
        margin-bottom: 15px;
        width: 80px;
      }
    }
    .info-item.qrcode {
      margin-bottom: 0;
    }
  }
  .footer-bottom {
    .slogan-box {
      img {
        height: auto;
        max-width: 90%;
      }
    }
    p {
      a {
        margin-top: 8px;
        margin-left: 0;
        display: block;
        font-size: 12px;
      }
      font-size: 12px;
    }
  }
  
  /* 超小屏幕移动端适配 (小于480px) */
  @media screen and (max-width: 479px) {
    .footer {
      padding: 30px 12px 15px;
      .info-item .item-title {
        font-size: 14px;
      }
      .info-item .text {
        font-size: 12px;
        line-height: 20px;
      }
      .info-item:first-child img,
      .info-item.qrcode img {
        width: 70px;
      }
    }
    .footer-bottom {
      p {
        font-size: 11px;
        padding-top: 20px;
      }
    }
  }
}
</style>
